export const ContentTypes = {
  GameRulesContent: 'gameRulesContent',
  BetContent: 'betContent',
  GameContent: 'gameContent',
  FairnessResultContent: 'fairnessResultContent',
  CheckHashContent: 'checkHashContent',
  HotKeysContent: 'hotKeysContent',
  AboutHashContent: 'aboutHashContent',
};
